import { render, staticRenderFns } from "./ImportEntity.vue?vue&type=template&id=5cc601b5&scoped=true&"
import script from "./ImportEntity.vue?vue&type=script&lang=js&"
export * from "./ImportEntity.vue?vue&type=script&lang=js&"
import style0 from "./ImportEntity.vue?vue&type=style&index=0&id=5cc601b5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc601b5",
  null
  
)

export default component.exports